module.exports = "<h1 matDialogTitle>Confirmation</h1>\n<div mat-dialog-content>{{confirmMessage}}</div>\n<div mat-dialog-actions class=\"pt-24\">\n    <button mat-raised-button class=\"mat-accent mr-16\" (click)=\"dialogRef.close(true)\">Confirmer</button>\n    <button mat-button (click)=\"dialogRef.close(false)\">Annuler</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main